const Component = () => import('./OrderHistory');

export { Component };
